/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  window.addEventListener('updateHistoryState', function (e) {
      let variantID = e.detail.id;
    console.log('ss',variantID);
      document.querySelectorAll('.thirdParties').forEach(et=>{
        et.classList.remove('active');
      });
      document.querySelector(`.thirdParties[data-id="${variantID}"]`).classList.add('active');
  });
})();
